import { LISCase, LISCaseList } from "pwapi";

import { useAppSelector } from "app/hooks";

const CasePriority = ({
  priorityCase,
}: {
  priorityCase: LISCaseList | LISCase;
}) => {
  const clinic = useAppSelector(
    (state) => state.clinics[priorityCase.patient?.clinic_id || 0]
  );

  return priorityCase.priority &&
    priorityCase.priority !== LISCaseList.priority.NORMAL ? (
    <span className={`Priority Priority--${priorityCase.priority}`}>
      {priorityCase.priority}
    </span>
  ) : clinic?.tat_priority ? (
    <span className={`Priority Priority--tat`}>Priority</span>
  ) : null;
};

export default CasePriority;
